import { render, staticRenderFns } from "./CategoryDeadline.vue?vue&type=template&id=1d48a838"
import script from "./CategoryDeadline.vue?vue&type=script&lang=js"
export * from "./CategoryDeadline.vue?vue&type=script&lang=js"
import style0 from "./CategoryDeadline.vue?vue&type=style&index=0&id=1d48a838&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports